export default "__VITE_PUBLIC_ASSET__854affbb__"